import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=587c0c37&scoped=true"
import script from "./architecture.vue?vue&type=script&lang=js"
export * from "./architecture.vue?vue&type=script&lang=js"
import style0 from "./architecture.vue?vue&type=style&index=0&id=587c0c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c0c37",
  null
  
)

export default component.exports